import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c4246e92&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c4246e92&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4246e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data0/web/xyadmin.98du.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4246e92')) {
      api.createRecord('c4246e92', component.options)
    } else {
      api.reload('c4246e92', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c4246e92&scoped=true", function () {
      api.rerender('c4246e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/fallsFlowManageConfig/fallsFlowManage/index.vue"
export default component.exports